import { CLIENT } from '@/configuration/gabed/emplacement/emplacementConf';
import generationEmplacement
  from '@/services/import/patrimoine/generation/emplacement/generationEmplacement';
import generationDispositif
  from '@/services/import/patrimoine/generation/dispositif/generationDispositif';
import formatDate from '@/services/general/formatIsoDate';
import generationMateriel
  from '@/services/import/patrimoine/generation/materiel/generationMateriel';
import generationFace from '@/services/import/patrimoine/generation/face/generationFace';

const getUniqueCodeDispo = (data) => {
  if (data.codeDispositif) return data.codeDispositif;
  const val = [
    data.supportDispositif || null,
    data.typeDispositif || null,
    data.adresse1Dispositif || null,
    data.codePostalDispositif || null,
    data.villeDispositif || null,
    data.dateMontageDispositif ? formatDate(data.dateMontageDispositif) : null || null,
    data.etatDispositif || null,
  ].filter(el => el).join('_');
  return val;
};

const getUniqueCodeMateriel = (data) => {
  const val = [
    data.idUniqueMateriel || null,
    data.codeMateriel || null,
    data.dispositionMateriel || null,
    data.formatMateriel || null,
    data.etatMateriel || null,
    data.typeMateriel || null,
  ].filter(el => el).join('_');
  return val;
};

export default function getPatrimoineConstruit(lignes, informationApiReference) {
  const emplacementCode = [...new Set(lignes.map((l) => l.codeEmplacement))];

  const errors = [];
  const patrimoine = [];
  emplacementCode.forEach((codeEmplacement) => {
    // recuperation des lignes de l'emplacement
    const allLigneOfTheEmplacement = lignes.filter((emplacement) => {
      return emplacement.codeEmplacement === codeEmplacement;
    });

    // par défaut les informations de l'emplacement seront ceux du premier emplacement
    // qui correspond au code
    const emplacementReference = allLigneOfTheEmplacement[0];
    const emplacement = generationEmplacement(emplacementReference, informationApiReference);
    if (emplacement.type === CLIENT && !emplacement.clientId) {
      errors.push({
        message: 'patrimoine.error.clientMustbeNullForImport',
        parametres: { numLigne: emplacementReference.numLigne },
      });
    }
    // récupération des dispositif de l'emplacement
    const dispositifsCode = [
      ...new Set(allLigneOfTheEmplacement.map(getUniqueCodeDispo)),
    ];

    // création des dispositifs
    dispositifsCode.filter(idUniqueDispo => idUniqueDispo).forEach((idUniqueDispo) => {
      allLigneOfTheEmplacement.forEach(l => { l.idUniqueDispo = getUniqueCodeDispo(l); });
      const ligneDispositif = allLigneOfTheEmplacement
        .find((l) => l.idUniqueDispo === idUniqueDispo);
      emplacement.dispositifs.push(generationDispositif(ligneDispositif, informationApiReference));
    });

    // récupération des matériel de l'emplacement
    const materielsCode = [
      ...new Set(allLigneOfTheEmplacement.map(getUniqueCodeMateriel)),
    ];
    materielsCode.filter(idUniqueDispo => idUniqueDispo).forEach((code) => {
      // recuperation des lignes de materiel
      const ligneMateriel = allLigneOfTheEmplacement.find((ligneOfEmplacement) => {
        return getUniqueCodeMateriel(ligneOfEmplacement) === code;
      });
      // generation du materiel
      const materiel = generationMateriel(ligneMateriel, informationApiReference);

      // recuperation des lignes de facefaces
      const lignesFace = allLigneOfTheEmplacement.filter((data) => {
        return getUniqueCodeMateriel(data) === code;
      });
      lignesFace.forEach((ligneFace) => {
        const face = generationFace(ligneFace);
        materiel.faces.push(face);
      });

      // on retrouve le dispositif et on ajoute le materiel qui contient les faces
      const dispositifOfEmplacement = emplacement.dispositifs.find((dispo) => {
        return dispo.idUniqueDispo === ligneMateriel.idUniqueDispo;
      });
      dispositifOfEmplacement.materiels.push(materiel);
    });
    patrimoine.push(emplacement);
  });
  if (errors.length) throw errors;
  return patrimoine;
}
